module.exports = __webpack_public_path__ + "img/olist.cf9be9e2.svg";